window.addEventListener('DOMContentLoaded', () => {
  if (document.querySelectorAll('.slider-twitter').length) {
    import('./_swiper.js').then((module) => {
      module.Init();
    });
  }
});
    
export default {}
  